import moment from 'moment';
import { head } from 'lodash';

class OfferFormController {
    constructor($rootScope, $scope, $state, offerService, messageService) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$state = $state;
        this.offerService = offerService;
        this.messageService = messageService;
    }

    $onInit () {
        this.offer = this.offer || {};
        this.offer.property_id = this.$rootScope.currentProperty.id;
        this.offer.pricing_value = (this.offer.pricing_type === '%') ? parseInt(this.offer.pricing_value) : this.offer.pricing_value || 0;

        if (this.offer.publish_at) {
            this.offer.publish_at = (this.offer.publish_at) ? moment(this.offer.publish_at, 'YYYY-MM-DD HH:mm:ss') : '';

        }
        if (this.offer.unpublish_at) {
            this.offer.unpublish_at = (this.offer.unpublish_at) ? moment(this.offer.unpublish_at, 'YYYY-MM-DD HH:mm:ss') : '';
        }
    }

    onSave () {
        delete (this.offer.grouped_events);
        delete (this.offer.grouped_exclusions);
        delete (this.offer.grouped_inclusions);

        if (this.offer.publish_at) {
            this.offer.publish_at = this.offer.publish_at.format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.offer.unpublish_at) {
            this.offer.unpublish_at = this.offer.unpublish_at.format('YYYY-MM-DD HH:mm:ss');
        }

        return this.offerService.save(this.offer)
            .then(response => {
                if (this.offer.id) {
                    if (!response.error) {
                        this.messageService.success(`The special offer <strong>${this.offer.name}</strong> was successfully updated!`, [`app.admin.offer-edit({ 'offer' : ${this.offer.id}})`, `Offer`]);
                        this.$state.go('app.admin.offers');
                    }
                } else {
                    this.messageService.success(`The special offer <strong>${response.name}</strong> was successfully created.`);
                    this.$state.go('app.admin.offer-edit', { offer: response.id, tab: 'period' });
                }
            })
            .catch((error) => {
                if (error.data.error.length && head(error.data.error).offer) {
                    let verb = (this.offer.id) ? 'updated' : 'created';
                    if (error.data.error.length) {
                        let errorList = '';
                        for (let errorLine of error.data.error) {
                            errorList += `<li>Conflicting offer period <strong>${errorLine.period.start}</strong> - <strong>${errorLine.period.end}</strong> for <strong>${errorLine.event}</strong> due to offer <strong>${errorLine.offer}</strong></li>`;
                        }
                        this.messageService.failure(`The offer <strong>${this.offer.name}</strong> could not be successfully ${verb}: <ul>${errorList}</ul>`);
                    } else {
                        this.messageService.failure(`The offer <strong>${this.offer.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
                    }

                    this.messageService.push();
                } else {
                    error.data = error.data.original || error.data;
        this.form.$api.setErrors(error.data);
                }
            });
    }

    currentDate () {
        return moment().format('LL');
    }

    setTime(start = null){
        if (start){
            return this.offer.publish_at && this.offer.publish_at.set({hour:0,minute:0,second:0,millisecond:0});
        }  
        return this.offer.unpublish_at && this.offer.unpublish_at.set({hour:23,minute:59,second:59,millisecond:59});
    }
}

OfferFormController.$inject = ['$rootScope', '$scope', '$state', 'offerService', 'messageService'];

export default OfferFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/offer/controllers/offer.form.controller.js